/** This mixin allows the getTotalAcres method to be called from different places on the app
 * @mixin */

export default {
  methods: {
    /**
     * @param {object} project - the project entity
     */
    getProjectTotalAcres(project) {
      // Get the sum of calculated acres from all Current-Status Properties
      let currentProperties = null;
      if (project.properties) {
        currentProperties = project.properties.filter(property => property.statusId === 1);
      }

      let calculatedAcres = 0;
      if (currentProperties) {
        calculatedAcres = currentProperties.map(cp => cp.calculatedAcres);
      }

      // Because of problems with floating-point logic and arithmethic
      // we use toFixed(4) (since we only allow 4 decimal digits on acres)
      // and we use casting to Number to get rid of trailing zeros.
      // See https://stackoverflow.com/questions/2876536/precise-financial-calculation-in-javascript-what-are-the-gotchas
      // and https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      return calculatedAcres ? Number(calculatedAcres.reduce((a, b) => a + b, 0).toFixed(4)) : 0;
    },
  },
};
